import React from 'react';
import styles from './styles.scss';
import classnames from 'classnames';
import LodIcon from 'components/util/lodIcon';

export default function TextField(props) {
  const isReduxForm = !!props.input;
  const onChange = isReduxForm ? props.input.onChange : props.onChange;
  let errorText = '';

  let settings = {
    id: props.id,
    placeholder: props.placeholder,
    type: props.type,
    ref: props.inputRef,
    maxLength: props.maxLength,
    autoFocus: props.autoFocus,
    style: props.style,
    name: props.name,
    onKeyPress: props.onKeyPress,
    onChange
  };

  if (isReduxForm) {
    errorText = props.meta.touched && !props.noValidate ? props.meta.error : '';
    settings = Object.assign(settings, props.input);
  } else {
    settings.value = props.value;
    settings.onChange = props.onChange;
    settings.onBlur = props.onBlur ? props.onBlur : null;
  }

  return (
    <div
      className={classnames(
        {
          [styles.error]: errorText,
          [styles.hasIcon]: props.icon,
          [styles.condensed]: props.condensed
        },
        styles.wrapper
      )}>
      <div className={styles.container}>
        {props.icon ? (
          <div className={styles.icon}>{<LodIcon icon={props.icon} />}</div>
        ) : null}
        <input {...settings} />
      </div>
      {errorText ? <div className={styles.errorText}>{errorText}</div> : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/util/textField/index.js